import React, { useState } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, Typography, IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useGlobalState } from '../../state';

const useStyles = makeStyles(theme => ({
  dialogTitle: {
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1.5, 2),
    '& h4': {
      color: theme.palette.primary.contrastText,
      fontSize: '1.25rem',
      fontWeight: 600,
    }
  },
  dialogHeaderContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    paddingRight: theme.spacing(1),
    minWidth: 0,
    overflow: 'hidden',
  },
  titleText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
  },
  langToggleWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
    borderRadius: '16px',
    padding: '2px',
    marginRight: theme.spacing(1),
  },
  langButton: {
    background: 'transparent',
    border: 'none',
    color: theme.palette.primary.contrastText,
    padding: '4px 10px',
    borderRadius: '14px',
    fontSize: '0.8125rem',
    fontWeight: 600,
    cursor: 'pointer',
    outline: 'none',
    transition: 'all 0.2s ease',
    opacity: 0.85,
    '&:hover': {
      opacity: 1,
    }
  },
  langButtonActive: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    opacity: 1,
    fontWeight: 700,
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.main,
    }
  },
  dialogContent: {
    overflow: 'hidden',
    padding: '0 !important',
    backgroundColor: '#000',
  },
  closeButton: {
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(0.75),
  },
}))

function VideoPopup({isOpen, onClose, videoUrl, verticalVideoUrl, hindiVideoUrl, title}) {
  const [{ user }] = useGlobalState();
  const isIndia = (user?.country || '').trim().toLowerCase() === 'india';

  const hasHindi = Boolean(hindiVideoUrl);
  const hasEnglish = Boolean(videoUrl || verticalVideoUrl);

  const [selectedLang, setSelectedLang] = useState(() => {
    const savedLang = localStorage.getItem('onboarding_video_lang');
    if (savedLang === 'hi' && hasHindi) return 'hi';
    if (savedLang === 'en' && hasEnglish) return 'en';
    if (isIndia && hasHindi) return 'hi';
    return hasEnglish ? 'en' : (hasHindi ? 'hi' : 'en');
  });

  const handleLanguageChange = (lang) => {
    setSelectedLang(lang);
    localStorage.setItem('onboarding_video_lang', lang);
  };

  const isSmallScreen = useMediaQuery('(max-width:600px)', {
    defaultMatches: true
  });
  const classes = useStyles({isSmallScreen});

  let activeVideoSrc = '';
  if (selectedLang === 'hi' && hasHindi) {
    activeVideoSrc = hindiVideoUrl;
  } else {
    activeVideoSrc = isSmallScreen ? (verticalVideoUrl || videoUrl) : (videoUrl || verticalVideoUrl);
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: {
          margin : isSmallScreen ? '0' : 'auto',
          width: isSmallScreen ? '100%' : '80%'
        }
      }}
      >
      <DialogTitle className={classes.dialogTitle} disableTypography>
        <div className={classes.dialogHeaderContent}>
          <div className={classes.titleWrapper}>
            <Typography variant="h4" className={classes.titleText}>{title}</Typography>
          </div>
          <div className={classes.headerActions}>
            {hasHindi && hasEnglish && (
              <div className={classes.langToggleWrapper}>
                <button
                  type="button"
                  className={`${classes.langButton} ${selectedLang === 'hi' ? classes.langButtonActive : ''}`}
                  onClick={() => handleLanguageChange('hi')}
                >
                  हिंदी
                </button>
                <button
                  type="button"
                  className={`${classes.langButton} ${selectedLang === 'en' ? classes.langButtonActive : ''}`}
                  onClick={() => handleLanguageChange('en')}
                >
                  Eng
                </button>
              </div>
            )}
            <IconButton className={classes.closeButton} aria-label="close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {activeVideoSrc && (
          <iframe
            key={activeVideoSrc}
            title={`video-${title}`}
            width="100%"
            height={isSmallScreen ? "400" : "315"}
            src={activeVideoSrc}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default VideoPopup